import React from "react";
import { Link, useParams } from "react-router-dom";
import { journal } from "@/data/journal";
import Reveal from "@/components/Reveal";

export default function JournalEntry() {
  const { slug } = useParams();
  const entry = journal.find((e) => e.slug === slug) || journal[0];

  return (
    <div data-testid="page-journal-entry" className="pt-32">
      {/* Header */}
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-8 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-2">
          <p className="font-eyebrow opacity-60">
            <Link to="/journal" data-testid="journal-back-link" className="editorial-link">
              ← Journal
            </Link>
          </p>
        </div>
        <div className="col-span-12 md:col-span-10">
          <Reveal>
            <p className="font-eyebrow" style={{ color: "#8C6B3F" }}>
              {entry.number} — {entry.category} — {entry.date}
            </p>
            <h1
              className="font-serif-display leading-[0.95] mt-8"
              style={{ fontSize: "clamp(2.5rem, 7vw, 7rem)" }}
            >
              {entry.title}
            </h1>
            <p
              className="font-serif-italic mt-8 opacity-80 max-w-3xl"
              style={{ fontSize: "clamp(1.25rem, 2vw, 1.8rem)" }}
            >
              {entry.dek}
            </p>
            <p className="font-eyebrow mt-8 opacity-60">
              By {entry.author} — {entry.readTime}
            </p>
          </Reveal>
        </div>
      </section>

      <div className="w-full h-[60vh] my-16 overflow-hidden">
        <img
          src={entry.cover}
          alt=""
          className="w-full h-full object-cover duotone"
        />
      </div>

      {/* Body — wireframe placeholder editorial */}
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-16 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-6 md:col-start-4">
          <Reveal>
            <p
              className="font-serif-display leading-relaxed"
              style={{ fontSize: "clamp(1.4rem, 2vw, 1.7rem)" }}
            >
              <span className="font-serif-italic" style={{ fontSize: "1.4em" }}>
                [ Opening
              </span>{" "}
              — the first paragraph, written in the tradition of an editorial
              leader. A single provocation, set against a long silence. ]
            </p>
            <p className="font-body opacity-80 mt-10 text-lg leading-relaxed">
              [ Body paragraph. This is where the essay unfolds — a considered
              argument, a field observation, a lesson from the ground. The
              rhythm is slow. The tone is calm. The intent is clarity. ]
            </p>
            <p className="font-body opacity-80 mt-6 text-lg leading-relaxed">
              [ Body paragraph. Case examples referenced without name-dropping.
              The reader is trusted to understand. ]
            </p>

            <blockquote
              className="my-16 pl-8 border-l"
              style={{ borderColor: "#8C6B3F" }}
            >
              <p
                className="font-serif-italic leading-tight"
                style={{ fontSize: "clamp(1.5rem, 2.4vw, 2rem)" }}
              >
                [ A pull-quote — the sentence readers will remember. ]
              </p>
            </blockquote>

            <p className="font-body opacity-80 mt-6 text-lg leading-relaxed">
              [ Closing paragraph. A return to the opening provocation, resolved
              with a quiet conviction. ]
            </p>

            <div className="mt-16 hairline" />
            <p className="font-eyebrow mt-8 opacity-60">
              — End of Volume Entry
            </p>
          </Reveal>
        </div>
      </section>

      {/* Continue */}
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-24 flex justify-between items-end">
        <div>
          <p className="font-eyebrow opacity-60">Return to</p>
          <h2 className="font-serif-display mt-4" style={{ fontSize: "clamp(2rem, 4vw, 3rem)" }}>
            The <span className="font-serif-italic">Journal</span>
          </h2>
        </div>
        <Link to="/journal" className="btn-ghost" data-testid="journal-entry-back">
          Archive <span className="arrow">→</span>
        </Link>
      </section>
    </div>
  );
}
